import { createSelector } from 'reselect';
import { createReducer, makeActionCreator } from './utils';
import * as API from '../webAPI/MKSService';

// Action types
export const SET_ANONYMOUS = 'user/SET_ANONYMOUS';
export const SET_AUTHENTICATED = 'user/SET_AUTHENTICATED';
//const SET_AUTHENTICATED_AS = 'user/SET_AUTHENTICATED_AS';
export const CLEAR = 'user/CLEAR';
export const RETRIEVE_USER_REQUEST = 'retrieve-user/REQUEST';
export const RETRIEVE_USER_SUCCESS = 'retrieve-user/SUCCESS';
export const RETRIEVE_USER_FAILURE = 'retrieve-user/FAILURE';

// Reducer
export const USER_TYPES = {
	UNKNOW: 0,
	ANONYMOUS: 1,
	AUTHENTICATED: 2
	//AUTHENTICATED_AS: 3
};
const initialState = {
	type: USER_TYPES.UNKNOW
};
export default createReducer(initialState, {
	[SET_ANONYMOUS]: (state, action) => ({ type: USER_TYPES.ANONYMOUS }),
	[SET_AUTHENTICATED]: (state, action) => ({
		type: USER_TYPES.AUTHENTICATED,
		...action.payload.user
	}),
	[CLEAR]: (state, action) => {
		return initialState;
	}
});

// Action creators
export function doSetAuthenticatedUser(user) {
	const userObject = {
		firstname: user.firstname,
		lastname: user.lastname,
		email: user.email,
		civility: user.civility || user.civility_title
	};

	return {
		type: SET_AUTHENTICATED,
		payload: {
			user: userObject
		}
	};
}

export const doSetAnonymousUser = makeActionCreator(SET_ANONYMOUS);
export const doClearUser = makeActionCreator(CLEAR);

export function doRetrieveUser() {
	return (dispatch, getState) => {
		const user = getUser(getState());

		if (user.type === USER_TYPES.UNKNOW) {
			dispatch(doRetrieveUserRequest());
		}
	};
}

const retrieveUserRequest = makeActionCreator(RETRIEVE_USER_REQUEST);
const retrieveUserSuccess = makeActionCreator(RETRIEVE_USER_SUCCESS, 'result');
const retrieveUserFailure = makeActionCreator(RETRIEVE_USER_FAILURE, 'error');
export function doRetrieveUserRequest() {
	return dispatch => {
		dispatch(retrieveUserRequest());
		API.ping().then(
			error => dispatch(retrieveUserFailure(error)),
			result => {
				// Need to check result !== null
				// Because typeof(null) in JS return object =/
				const isAuthenticated =
					result !== null &&
					typeof result === 'object' &&
					result.hasOwnProperty('user');
				if (isAuthenticated) {
					dispatch(doSetAuthenticatedUser(result.user));
				} else {
					dispatch(doSetAnonymousUser());
				}

				// Need to be dispatched at the end
				dispatch(retrieveUserSuccess(result));
			}
		);
	};
}

// Selectors
export const getUser = state => state.user;

export const getIsAuthenticated = createSelector(
	getUser,
	user => user.type === USER_TYPES.AUTHENTICATED
);

export const getIsAnonymous = createSelector(
	getUser,
	user => user.type === USER_TYPES.ANONYMOUS
);

// TODO: replace this selector calls by getIsAuthenticated()
export const getIsLoggedIn = createSelector(
	getUser,
	user => Object.keys(user).length !== 0
);



// WEBPACK FOOTER //
// ./src/js/reducers/user.js